import { createSlice } from '@reduxjs/toolkit'

export interface TeamAndSportByStoreState {
  [storeId: string]: {
    sport?: number
    team?: number
  }
}
const teamAndSportByStoreSlice = createSlice({
  name: 'teamAndSportByStore',
  initialState: {
    teamAndSportByStore: null
  },
  reducers: {
    setTeamAndSportByStore: (state, action) => {
      const { store, sport, team } = action.payload
      const storeId = String(store)
      const newState = { ...state }
      let storeInfo: { sport?: number; team?: number } = newState[storeId] || {}

      if (sport) {
        storeInfo = { ...storeInfo, sport }
      }
      if (team) {
        storeInfo = { ...storeInfo, team }
      }

      newState[storeId] = { ...newState[storeId], ...storeInfo }
      return newState
    }
  }
})

export const { setTeamAndSportByStore } = teamAndSportByStoreSlice.actions

export default teamAndSportByStoreSlice.reducer
